import { useEffect } from "react";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";
import { useT } from "@/lib/i18n";

const SORO_SRC = "https://app.trysoro.com/api/embed/1c04b9dc-06e8-4c56-8ec4-8afb4a0b8810";

export default function Blog() {
  const t = useT();
  useEffect(() => {
    // O widget do Soro procura a div #soro-blog ao carregar — injeta o script
    // após o mount e remove no unmount pra não duplicar ao navegar de volta.
    const s = document.createElement("script");
    s.src = SORO_SRC;
    s.defer = true;
    document.body.appendChild(s);
    return () => { document.body.removeChild(s); };
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="blog-page">
      <MarketingNav />
      <section className="max-w-5xl mx-auto px-6 lg:px-8 pt-24 pb-16">
        <div className="overline mb-4">// blog</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mb-10">
          {t("blog.title")}
        </h1>
        {/* O tema claro do widget do Soro é sobrescrito em index.css (#soro-blog). */}
        <div id="soro-blog" />
      </section>
      <MarketingFooter />
    </div>
  );
}
